import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  IonContent,
  IonIcon,
  IonItem,
  IonList,
  IonListHeader,
  alertController,
  popoverController
} from "@ionic/vue";
import { ref } from "vue";
import { lockClosedOutline, lockOpenOutline } from 'ionicons/icons'
import { translate } from '@hotwax/dxp-components';
import { showToast } from '@/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderLimitPopover',
  props: ["fulfillmentOrderLimit"],
  setup(__props) {

const props = __props;
const setLimit = ref(props.fulfillmentOrderLimit) as any;

async function updateOrderLimitType(orderLimitType: string) {
  let header = "Unlimited fulfillment capacity"
  let message = "Unlimited capacity removes the fulfillment capacity limit entirely. To add a fulfillment capacity to this facility, use the custom option."
  let showInput = false

  if(orderLimitType === 'custom') {
    header = "Custom fulfillment capacity"
    message = ""
    showInput = true
  } else if (orderLimitType === 'no-capacity') {
    setLimit.value = 0
    header = "No fulfillment capacity"
    message = "No capacity sets the fulfillment capacity to 0, preventing any new orders from being allocated to this facility. To add a fulfillment capacity to this facility, use the custom option."
  } else if (orderLimitType === 'unlimited') {
    setLimit.value = ""
  }

  showOrderLimitAlert(header, message, showInput)
}

async function showOrderLimitAlert(header: string, message: string, showInput: boolean) {
  const alert = await alertController.create({
    header: translate(header),
    message: translate(message, {space: '</br></br>'}),
    inputs: showInput ? [{
      name: "setLimit",
      placeholder: translate("Order fulfillment capacity"),
      type: "number",
      value: props.fulfillmentOrderLimit?.toString(),
      min: 0
    }] : [],
    buttons: [{
      text: translate('Cancel'),
      role: "cancel"
    },
    {
      text: translate('Apply'),
      handler: (data) => {
        let value = setLimit.value as any;

        if(data) {
          if(data.setLimit === '') {
            showToast(translate('Please provide a value'))
            return false;
          } else if(data.setLimit <= 0) {
            showToast(translate('Provide a value greater than 0'))
            return false;
          } else {
            value = data.setLimit
          }
        }

        popoverController.dismiss(value)
      }
    }]
  })
  alert.present()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonList), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonListHeader), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(translate)("Fulfillment capacity")), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItem), {
            button: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (updateOrderLimitType('unlimited')))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "end",
                icon: _unref(lockOpenOutline)
              }, null, 8, ["icon"]),
              _createTextVNode(" " + _toDisplayString(_unref(translate)("Unlimited Capacity")), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItem), {
            button: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (updateOrderLimitType('no-capacity')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(translate)("No Capacity")) + " ", 1),
              _createVNode(_unref(IonIcon), {
                slot: "end",
                icon: _unref(lockClosedOutline)
              }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItem), {
            button: "",
            lines: "none",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (updateOrderLimitType('custom')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(translate)("Custom")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})